<template>
  <div class="article-tiles-container">
    <h1>{{ articlesTitle }}</h1>
    <h2>
      {{ articlesDescription }}
    </h2>
    <div class="child">
      <ArticleTiles :tiles="tiles" @buttonClicked="readMore" />
    </div>
  </div>
</template>

<script>
  import ArticleTiles from './ArticleTiles.vue';

  export default {
    name: 'ArticleTilesContainer',
    components: {
      ArticleTiles,
    },
    data() {
      return {
        articlesTitle: 'Expert Insights',
        articlesDescription: `Our experts have put together articles on specific topics, helping you to
      make the best decisions for your future.`,
      };
    },
    props: {
      tiles: {
        required: true,
        type: Array,
        default: () => [],
      },
      articles: {
        required: true,
        type: Array,
        default: () => [],
      },
    },
    methods: {
      readMore(id) {
        const article = this.articles.find(article => article.id === id);
        this.$router.push({
          name: 'Article',
          params: {
            title: article.route,
          },
        });
      },
    },
    created() {
      if (['Articles', 'Article'].includes(this.$route.name)) {
        this.articlesTitle = 'More articles';
        this.articlesDescription =
          'Explore more expert articles to help you make informed decisions about your future.';
      }
    },
  };
</script>

<style scoped lang="scss">
  .article-tiles-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    h1 {
      max-width: 928px;
      font-family: Montserrat;
      font-size: 28px;
      font-weight: 500;
      line-height: 34px;
      letter-spacing: -0.0025em;
      text-align: center;
      span {
        font-family: Montserrat;
        font-size: 28px;
        font-weight: 500;
        line-height: 34px;
        letter-spacing: -0.0025em;
        text-align: center;
      }
    }
    h2 {
      max-width: 928px;
      margin-top: 22px;
      font-family: Montserrat;
      font-size: 22px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
    }
    span {
      font-family: Montserrat;
      font-size: 22px;
      font-weight: 600;
      line-height: 26px;
      text-align: center;
    }

    .child {
      margin-top: 56px;
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .article-tiles-container {
      h2 {
        font-size: 18px;
      }
      span {
        font-size: 18px;
      }
    }
  }
</style>
